
import vue from 'vue';
import PredialService from '@/services/PredialService';
import rules from '@/mixins/rules';

export default vue.extend({
    name: 'PredialEstadoCuenta',
    mixins: [rules],
    props: {
        dialogEstadoCuenta: {
            type: Boolean,
            default: false
        },
        establecimiento: {
            type: Object,
            default: null as any
        }
    },
    data: () => ({
        dialogDocument: false,
        dialogSolicitud: false,
        documento: null as any,
        datosPredio: null as any,
        initialYear: 2010,
        parcialidad: 2 as any,
        currentYear: new Date().getFullYear(),
        year: new Date().getFullYear(),
        formEdoCuenta: {
            claveCatastral: null,
            tipoCuenta: 2,
            bimestre: null,
            yearInicio: null,
            yearFinal: null,
            ultimoPagoPredial: null as any,
        },
        formEdoCuentaDesglosado: {
            claveCatastral: null,
            tipoCuenta: null,
            bimestre: null,
            yearInicio: null,
            yearFinal: null,
            avaluos: [] as any,
            datosPredio: {} as any,
            ultimoPagoPredial: null as any,
        },
        avaluos: [] as any,
        pagos: {} as any,
        claveCatastral: '',
        parcialidades: [
            { id: 2, descripcion: '2 parcialidades' },
            { id: 3, descripcion: '3 parcialidades' },
            { id: 4, descripcion: '4 parcialidades' },
        ],
    }),
    methods: {
        closeEstadoCuenta() {
            //@ts-ignore
            this.formEdoCuentaDesglosado = {
                claveCatastral: null,
                tipoCuenta: null,
                bimestre: null,
                yearInicio: null,
                yearFinal: null,
                avaluos: [] as any,
                datosPredio: {} as any,
            }
            this.avaluos = [] as any;
            this.$emit('closeEstadoCuenta');
        },
        generarEdoCuentaSolicitudes() {
            console.log(this.establecimiento.clave_catastral);
            PredialService.generarEdoCuentaSolicitudes(this.formEdoCuenta)
                .then((response) => {
                    let file = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(file);
                    const tipoArchivo = 'Estado de cuenta'
                    //@ts-ignore
                    this.documento = {
                        title: tipoArchivo,
                        url: url,
                        mime: response.headers['content-type']
                    }
                    this.dialogDocument = true;
                })
        },
        getValuacionClaveCatastral() {
            PredialService.getValuacionClaveCatastral(this.formEdoCuenta)
                .then((response) => {
                    let res = response.data;
                    this.avaluos = res.data.avaluos
                    this.datosPredio = res.data.datos_predio
                    this.formEdoCuentaDesglosado.datosPredio = res.data.datos_predio
                })
        },
        generarEdoCuentaDesglosado() {
            let anioFin = this.formEdoCuentaDesglosado.ultimoPagoPredial.anio_fin;
            let anioInicio = new Date().getFullYear();
            let data = {
                claveCatastral: this.formEdoCuentaDesglosado.claveCatastral,
                tipoCuenta: this.formEdoCuentaDesglosado.tipoCuenta,
                bimestre: this.formEdoCuentaDesglosado.bimestre,
                yearInicio: this.formEdoCuentaDesglosado.yearInicio,
                yearFinal: this.formEdoCuentaDesglosado.yearFinal,
                avaluos: this.avaluos
                    .filter((avaluo: any) => {
                        let year = new Date(avaluo.fecha).getFullYear();
                        return year >= anioFin && year <= anioInicio;
                    })
                    .sort((a: any, b: any) => new Date(a.fecha).getTime() - new Date(b.fecha).getTime()),
                datosPredio: this.formEdoCuentaDesglosado.datosPredio,
            }
            PredialService.generarEdoCuentaDesglosadoSolicitud(data)
                .then((response) => {
                    let file = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(file);
                    const tipoArchivo = 'Estado de cuenta'
                    //@ts-ignore
                    this.documento = {
                        title: tipoArchivo,
                        url: url,
                        mime: response.headers['content-type']
                    }
                    this.dialogDocument = true;
                })
        },
        async getUltimoPagoPredial() {
            let data = {
                claveCatastral: this.establecimiento.clave_catastral,
            }
            PredialService.getUltimoPagoPredial(data)
                .then((response) => {
                    this.pagos = response.data.data;
                    if (response.data.success) {
                        if (this.pagos) {
                            this.formEdoCuenta.ultimoPagoPredial = this.pagos;
                            this.formEdoCuentaDesglosado.ultimoPagoPredial = this.pagos;
                        }
                        this.$toast.success(response.data.message);
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    //console.log(error.response.data.message);
                })
        },
        solicitarConvenioPredial() {
            let data = {
                clave_catastral: this.establecimiento.clave_catastral,
                parcialidades: this.parcialidad
            }
            PredialService.solicitarConvenioPredial(data)
            .then((response) => {
                if (response.data.success) {
                    this.dialogSolicitud = false;
                    this.$toast.success(response.data.message);
                } else {
                    this.$toast.error(response.data.message);
                }
            })
        }
    },
    computed: {
        arrayYears() {
            let arrayYears: any = [];
            for (let i = this.currentYear; i >= this.initialYear; i--) {
                arrayYears.push(i);
            }
            return arrayYears;
        },
    },
    watch: {
        dialogEstadoCuenta: function () {
            if (this.dialogEstadoCuenta) {
                console.log(this.establecimiento);

                this.formEdoCuenta.claveCatastral = this.establecimiento.clave_catastral;
                this.formEdoCuentaDesglosado.claveCatastral = this.establecimiento.clave_catastral;
                this.getUltimoPagoPredial();
                this.getValuacionClaveCatastral();
            }
        },
    }
});
